import { CSSProperties, ReactNode } from "react";
import { HeroKey, heroImage } from "../constants/photos";

export interface HeroProps {
  photo: HeroKey;
  title: ReactNode;
  kicker?: string;
  body?: ReactNode;
  cta?: { label: string; href: string };
  aside?: ReactNode;
  size?: "lg" | "md" | "sm";
  focus?: string;
  zoom?: string;
  align?: "start" | "end";
  className?: string;
}

export default function HeroCard({ photo, title, kicker, body, cta, aside, size = "md", focus = "center", zoom, align = "start", className }: HeroProps) {
  const style: CSSProperties = { backgroundImage: heroImage(photo, size), backgroundPosition: focus, ...(zoom ? { backgroundSize: zoom } : {}) };
  return (
    <section className={`hero hero-${size}${align === "end" ? " hero-end" : ""}${className ? ` ${className}` : ""}`} style={style}>
      <div className="hero-body">
        {kicker && <div className="hero-kicker">{kicker}</div>}
        <h2 className="hero-title">{title}</h2>
        {body && <p className="hero-text">{body}</p>}
        {cta && <a className="hero-cta" href={cta.href}>{cta.label} <span aria-hidden="true">→</span></a>}
      </div>
      {aside && <div className="hero-aside">{aside}</div>}
    </section>
  );
}
